import { cached } from '@porotutu/react'
import { listQueryOf } from '@porotutu/react/paging'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { permittedRoute, signedInRoute } from '@/router/root'
import { CRM_PRODUCT_SORTABLE } from '../vocabulary'
import { productQuery, productsQuery } from './queries'

const productSearch = (raw: Record<string, unknown>) => listQueryOf(raw, CRM_PRODUCT_SORTABLE)

export const productsRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('products'),
  path: '/products',
  validateSearch: productSearch,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => context.queryClient.query(cached(productsQuery(deps))),
  component: lazyRouteComponent(() => import('./pages'), 'ProductsPage'),
})

export const productRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('products'),
  path: '/products/$id',
  validateSearch: productSearch,
  loader: ({ context, params }) => context.queryClient.query(cached(productQuery(params.id))),
  component: lazyRouteComponent(() => import('./pages'), 'ProductPage'),
})

export const productRoutes = [productsRoute, productRoute]
